import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.32 2.577C10.094 2.13886 13.906 2.13886 17.68 2.577C19.177 2.751 20.25 4.037 20.25 5.507V21C20.2498 21.1277 20.217 21.2533 20.1547 21.3648C20.0925 21.4763 20.0027 21.57 19.8941 21.6371C19.7854 21.7042 19.6614 21.7425 19.5338 21.7482C19.4062 21.754 19.2793 21.727 19.165 21.67L12 18.089L4.835 21.672C4.72058 21.7291 4.59345 21.756 4.4657 21.7502C4.33795 21.7443 4.21381 21.7059 4.10509 21.6386C3.99637 21.5712 3.90667 21.4772 3.84452 21.3655C3.78237 21.2537 3.74983 21.1279 3.75 21V5.507C3.75 4.037 4.823 2.751 6.32 2.577Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }